import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "overflow-hidden rounded-lg border border-slate-200 bg-white"
};
const _hoisted_2 = {
  class: "border-b border-slate-200 px-4 py-3"
};
const _hoisted_3 = {
  class: "flex flex-wrap items-center justify-between gap-3"
};
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
  class: "mt-3 grid grid-cols-3 gap-2"
};
const _hoisted_6 = {
  class: "text-xs font-medium"
};
const _hoisted_7 = {
  class: "mt-1 text-lg font-semibold leading-none"
};
const _hoisted_8 = {
  key: 0,
  class: "data-table-empty is-compact"
};
const _hoisted_9 = {
  key: 1,
  class: "divide-y divide-slate-100"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_12 = {
  class: "truncate text-sm font-semibold text-slate-900"
};
const _hoisted_13 = {
  class: "mt-1 text-sm text-slate-700"
};
const _hoisted_14 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_15 = {
  key: 2,
  class: "border-t border-red-100 bg-red-50 px-4 py-2 text-xs font-medium text-red-700"
};
import { computed } from 'vue';
export default {
  __name: 'InvoiceValidationPanel',
  props: {
    issues: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    syncing: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  emits: ['validate', 'locate'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const busy = computed(() => props.loading || props.syncing);
    const counters = computed(() => [{
      key: 'ERROR',
      label: 'ERROR',
      count: countBySeverity('ERROR'),
      className: 'border-red-100 bg-red-50 text-red-700'
    }, {
      key: 'WARNING',
      label: 'WARNING',
      count: countBySeverity('WARNING'),
      className: 'border-amber-100 bg-amber-50 text-amber-700'
    }, {
      key: 'INFO',
      label: 'INFO',
      count: countBySeverity('INFO'),
      className: 'border-blue-100 bg-blue-50 text-blue-700'
    }]);
    function severity(issue) {
      return String(issue?.severity || issue?.level || 'INFO').toUpperCase();
    }
    function countBySeverity(value) {
      return props.issues.filter(issue => severity(issue) === value).length;
    }
    function severityMeta(value) {
      if (value === 'ERROR') return {
        className: 'status-badge is-danger'
      };
      if (value === 'WARNING') return {
        className: 'status-badge is-warning'
      };
      return {
        className: 'status-badge is-info'
      };
    }
    function firstValue(...values) {
      return values.find(value => value !== null && value !== undefined && value !== '') ?? null;
    }
    function relatedText(issue) {
      const chain = firstValue(issue?.chainNo, issue?.chainId);
      const customer = firstValue(issue?.customerName, issue?.companyNameSnapshot, issue?.companyName);
      if (chain && customer) return `链路 ${chain} · ${customer}`;
      if (chain) return `链路 ${chain}`;
      if (customer) return customer;
      return '';
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "min-w-0"
      }, [_createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "校验面板"), _createElementVNode("p", {
        class: "mt-1 text-sm text-slate-500"
      }, "ERROR / WARNING / INFO")], -1)), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary inline-flex items-center gap-1.5",
        disabled: busy.value,
        onClick: _cache[0] || (_cache[0] = $event => emit('validate'))
      }, " 重新校验 ", 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(counters.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.key,
          class: _normalizeClass(['rounded-md border px-3 py-2', item.className])
        }, [_createElementVNode("p", _hoisted_6, _toDisplayString(item.label), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(item.count), 1)], 2);
      }), 128))])]), __props.issues.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 暂无校验问题 ")) : (_openBlock(), _createElementBlock("ul", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.issues, (issue, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: issue.id || `${issue.ruleCode || 'rule'}-${index}`,
          class: "cursor-pointer px-4 py-3 transition-colors hover:bg-slate-50",
          onClick: $event => emit('locate', issue)
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", {
          class: _normalizeClass(['status-badge', severityMeta(severity(issue)).className])
        }, _toDisplayString(severity(issue)), 3), _createElementVNode("span", _hoisted_12, _toDisplayString(issue.ruleCode || '-'), 1)]), _createElementVNode("p", _hoisted_13, _toDisplayString(issue.message || '-'), 1), relatedText(issue) ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(relatedText(issue)), 1)) : _createCommentVNode("", true)], 8, _hoisted_10);
      }), 128))])), __props.hasError ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 存在 ERROR 问题，需处理后才能确认方案。 ")) : _createCommentVNode("", true)]);
    };
  }
};